import { render, staticRenderFns } from "./InstructorSessions.vue?vue&type=template&id=5b9805be&scoped=true"
import script from "./InstructorSessions.vue?vue&type=script&lang=js"
export * from "./InstructorSessions.vue?vue&type=script&lang=js"
import style0 from "./InstructorSessions.vue?vue&type=style&index=0&id=5b9805be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9805be",
  null
  
)

export default component.exports